import { LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import ProductPageDesktop from "@/pages-react/product-page/ProductPageDesktop.tsx";
import ProductPageMobile from "@/pages-react/product-page/ProductPageMobile.tsx";
import { ProductPageStore, useProductPageCommon } from "./ProductPageCommon";
import { ProductStateType } from "@/util/constants.ts";
import { GonePage } from "@/pages-react/gone-page/GonePage.tsx";
import { ProductAnaloguePage } from "@/pages-react/product-analogue-page/ProductAnaloguePage.tsx";
import { getFilteredCrosses } from "@/helpers/product-manager.ts";

const getPageComponent = (layoutType: LayoutTypes) => {
  switch (layoutType) {
    case LayoutTypes.TYPE_DESKTOP:
      return ProductPageDesktop;
    case LayoutTypes.TYPE_MOBILE:
      return ProductPageMobile;
  }
};

const productIsGone = (store: ProductPageStore) => {
  const product = store.state.product;

  if (!product?.id) {
    return true;
  }

  if ([ProductStateType.Active, ProductStateType.OnRequest].includes(product.state)) {
    return false;
  }

  const hasStock = product.prices?.find((item) => !!item.availableStockCount);

  return !hasStock;
};

export const ProductPage = (props: { store: ProductPageStore }) => {
  const { layoutType } = useLayoutType();

  const PageComponent = getPageComponent(layoutType);
  const hasPrices = !!props.store.state?.product?.prices;
  const hasStock = hasPrices && !!props.store.state?.product?.prices?.find((item: any) => !!item.availableStockCount);

  if (!hasStock && props.store.state?.product?.redirectUrl) {
    location.href = props.store.state.product.redirectUrl;
  }

  if (productIsGone(props.store)) {
    if (getFilteredCrosses(props.store.state?.product).length > 0) {
      return <ProductAnaloguePage layout={layoutType} store={props.store} />;
    }

    return <GonePage>{props.store.state.product.mpnFormatted}</GonePage>;
  }

  return <PageComponent store={props.store} key={props.store.state.product.id} />;
};
